import React from 'react';
export function Divider() {
  return <div className="flex items-center justify-center py-12" data-id="element-27">
      <div className="h-px w-24 bg-gold/40" data-id="element-28"></div>
      <div className="w-2 h-2 rounded-full bg-gold mx-4" data-id="element-29"></div>
      <div className="h-px w-24 bg-gold/40" data-id="element-30"></div>
    </div>;
}